export const NAMESPACE = 'tangram-design-system';